import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';

/**
 * Compact gear/kit thumbnail with built-in error fallback. Used across the
 * project page tabs. Accepts `size = 'sm' | 'md'`.
 */
export default function Thumb({ src, name, size = 'sm' }) {
  const [err, setErr] = useState(false);
  const dims = size === 'sm' ? 'h-8 w-12' : 'h-10 w-14';
  if (!src || err) {
    return (
      <div
        className={`${dims} rounded bg-neutral-900 border border-neutral-800 grid place-items-center text-neutral-600`}
      >
        <ImageOff size={12} />
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={name}
      onError={() => setErr(true)}
      className={`${dims} object-cover rounded border border-neutral-800`}
    />
  );
}
